import { render, staticRenderFns } from "./UserRegisterInputPage.vue?vue&type=template&id=67c6e809&scoped=true"
import script from "./UserRegisterInputPage.vue?vue&type=script&lang=ts"
export * from "./UserRegisterInputPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c6e809",
  null
  
)

export default component.exports